import "../../styles/blog.css";

// ── Inline SVG icons ────────────────────────────────────────────

function IconShield() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  );
}

function IconRoute() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="6" cy="19" r="3" />
      <path d="M9 19h8.5a3.5 3.5 0 000-7h-11a3.5 3.5 0 010-7H15" />
      <circle cx="18" cy="5" r="3" />
    </svg>
  );
}

function IconBridge() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 12h20" />
      <path d="M6 12V6a6 6 0 0112 0v6" />
      <path d="M2 12v4h20v-4" />
    </svg>
  );
}

function IconGitHub() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
    </svg>
  );
}

// ── Feature definitions ─────────────────────────────────────────

const FEATURES = [
  { name: "Chat", desc: "Multi-model AI conversations", color: "#4f8fff", icon: "M5 3l14 9-14 9V3z" },
  { name: "File Browser", desc: "Navigate and edit project files", color: "#a78bfa", icon: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z M14 2v6h6" },
  { name: "Canvas", desc: "Visual workspace for diagrams", color: "#38bdf8", icon: "M3 3h18v18H3z M3 9h18 M9 21V9" },
  { name: "Task Board", desc: "Kanban-style project tracking", color: "#34d399", icon: "M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z" },
  { name: "Access Control", desc: "RBAC policies and entity management", color: "#fbbf24", icon: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z M9 12l2 2 4-4" },
  { name: "Cost Ledger", desc: "Token usage, spend tracking", color: "#ff79c6", icon: "M12 1v22 M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" },
  { name: "Arch Map", desc: "Live architecture visualization", color: "#4f8fff", icon: "M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" },
  { name: "Quarantine", desc: "Isolate and review risky outputs", color: "#f87171", icon: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" },
  { name: "Knowledge Base", desc: "Searchable project knowledge", color: "#a78bfa", icon: "M12 2a10 10 0 100 20 10 10 0 000-20z M12 8v8 M8 12h8" },
  { name: "Registry", desc: "Plugin and tool registry", color: "#38bdf8", icon: "M21 8V5a2 2 0 00-2-2H5a2 2 0 00-2 2v3 M3 16v3a2 2 0 002 2h14a2 2 0 002-2v-3 M12 12m-3 0a3 3 0 106 0 3 3 0 00-6 0 M1 12h4 M19 12h4" },
  { name: "Drift Detection", desc: "Monitor config and state drift", color: "#fbbf24", icon: "M22 12h-4l-3 9L9 3l-3 9H2" },
  { name: "Benchmark", desc: "Evaluate model performance", color: "#34d399", icon: "M12 20V10 M18 20V4 M6 20v-4" },
] as const;

// ── Component ───────────────────────────────────────────────────

export function BlogWorkbench() {
  const navigateHome = () => {
    window.location.hash = "home";
  };

  return (
    <div className="blog-landing">
      <div className="blog-landing__grid" />

      <div className="blog-landing__content">
        {/* ── Nav ── */}
        <nav className="blog-nav">
          <div className="blog-nav__brand">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <rect x="2" y="2" width="20" height="20" rx="4" stroke="url(#bgrad)" strokeWidth="2" />
              <circle cx="12" cy="12" r="3" fill="url(#bgrad)" />
              <defs>
                <linearGradient id="bgrad" x1="0" y1="0" x2="24" y2="24">
                  <stop offset="0%" stopColor="#4f8fff" />
                  <stop offset="100%" stopColor="#a78bfa" />
                </linearGradient>
              </defs>
            </svg>
            <span style={{ color: '#4f8fff', fontWeight: 700 }}>&gt;</span>{' '}<span style={{ color: '#e6edf3', fontWeight: 700 }}>tool</span><span style={{ color: '#4f8fff', fontWeight: 700 }}>_os</span>
            <span style={{ color: "var(--ot-text-muted)", marginLeft: 8 }}>by OpenTool</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <span className="blog-nav__date">April 2026</span>
            <button className="blog-nav__back" onClick={navigateHome}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
              Back to Desktop
            </button>
          </div>
        </nav>

        {/* ── Hero ── */}
        <section className="blog-hero">
          <div className="blog-hero__orb" />

          <div className="blog-hero__eyebrow">
            <span className="blog-hero__eyebrow-dot" />
            Introducing ToolOS
          </div>

          <h1 className="blog-hero__title">
            One Operating System<br />
            for <span className="blog-hero__title-gradient">All AI Tooling</span>
          </h1>

          <p className="blog-hero__subtitle">
            Stop managing a dozen AI tools with a dozen policies. ToolOS gives your
            organization a single control surface for every AI developer tool, agent runtime,
            and model provider &mdash; with the RBAC, routing, and cost controls you actually need.
          </p>
        </section>

        <hr className="blog-divider" />

        {/* ── Section 1: The Problem ── */}
        <section className="blog-section">
          <span className="blog-section__label">The Problem</span>
          <h2 className="blog-section__heading">AI Tools Are Fragmented Islands</h2>
          <p className="blog-section__text">
            Your developers are using <strong>Claude Code, Codex CLI, Cursor, GitHub Copilot,
            ChatGPT, local Ollama models</strong> &mdash; often all at once. Each tool has its own
            auth, its own billing, its own idea of what the AI can access. Your security team
            has no visibility. Your finance team gets surprise invoices. Your compliance team
            can not audit anything.
          </p>
          <p className="blog-section__text">
            Every AI tool is a silo. <strong>There is no unified layer for governance, cost control,
            or intelligent routing.</strong> Until now.
          </p>

          <div className="blog-problem-grid">
            {[
              { icon: "\u{1F916}", name: "Claude Code", status: "Separate billing" },
              { icon: "\u{1F4BB}", name: "Codex CLI", status: "No RBAC" },
              { icon: "\u{1F3AF}", name: "Cursor", status: "No audit trail" },
              { icon: "\u{2728}", name: "GitHub Copilot", status: "Per-seat lock-in" },
              { icon: "\u{1F9E0}", name: "ChatGPT", status: "Shadow IT risk" },
              { icon: "\u{1F4E6}", name: "Ollama", status: "No central policy" },
            ].map((tool) => (
              <div key={tool.name} className="blog-problem-card">
                <div className="blog-problem-card__icon">{tool.icon}</div>
                <div className="blog-problem-card__name">{tool.name}</div>
                <div className="blog-problem-card__status">{tool.status}</div>
              </div>
            ))}
          </div>
        </section>

        <hr className="blog-divider" />

        {/* ── Section 2: The Vision ── */}
        <section className="blog-section">
          <span className="blog-section__label">The Vision</span>
          <h2 className="blog-section__heading">
            Same Core. Different Surfaces.
          </h2>
          <p className="blog-section__text">
            ToolOS is <strong>one codebase</strong> that ships as four deployment surfaces.
            Whether your team needs a browser workstation, a headless CI runner, a Kubernetes
            operator, or a centralized control plane &mdash; it is the same software, the same
            policies, the same audit trail.
          </p>

          <div className="blog-surfaces-grid">
            <div
              className="blog-surface-card"
              style={{
                "--card-accent": "#4f8fff",
                "--card-glow": "rgba(79, 143, 255, 0.08)",
                "--card-icon-bg": "rgba(79, 143, 255, 0.1)",
                "--card-icon-border": "rgba(79, 143, 255, 0.15)",
              } as React.CSSProperties}
            >
              <div className="blog-surface-card__icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4f8fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                  <path d="M8 21h8M12 17v4" />
                </svg>
              </div>
              <h3 className="blog-surface-card__title">Developer Platform</h3>
              <p className="blog-surface-card__desc">
                Browser-based workstation for daily development. Chat, file browser, canvas,
                task board &mdash; your entire AI-augmented workflow in one window. Served as a
                React SPA backed by a Rust binary.
              </p>
            </div>

            <div
              className="blog-surface-card"
              style={{
                "--card-accent": "#a78bfa",
                "--card-glow": "rgba(167, 139, 250, 0.08)",
                "--card-icon-bg": "rgba(167, 139, 250, 0.1)",
                "--card-icon-border": "rgba(167, 139, 250, 0.15)",
              } as React.CSSProperties}
            >
              <div className="blog-surface-card__icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#a78bfa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="4" y="4" width="16" height="16" rx="2" />
                  <path d="M9 9l3 3-3 3M15 15h-3" />
                </svg>
              </div>
              <h3 className="blog-surface-card__title">Server Agent Runtime</h3>
              <p className="blog-surface-card__desc">
                Headless agent execution for CI/CD pipelines and automation. Same policies,
                same routing, no UI required. Runs as a single binary alongside your build
                system.
              </p>
            </div>

            <div
              className="blog-surface-card"
              style={{
                "--card-accent": "#38bdf8",
                "--card-glow": "rgba(56, 189, 248, 0.08)",
                "--card-icon-bg": "rgba(56, 189, 248, 0.1)",
                "--card-icon-border": "rgba(56, 189, 248, 0.15)",
              } as React.CSSProperties}
            >
              <div className="blog-surface-card__icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" />
                  <path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12" />
                </svg>
              </div>
              <h3 className="blog-surface-card__title">K8s Agent Runtime</h3>
              <p className="blog-surface-card__desc">
                Cloud-native orchestration at scale. Deploy agent workloads as Kubernetes pods
                with CRD-based configuration. Auto-scaling, health checks, and resource limits
                built in.
              </p>
            </div>

            <div
              className="blog-surface-card"
              style={{
                "--card-accent": "#fbbf24",
                "--card-glow": "rgba(251, 191, 36, 0.08)",
                "--card-icon-bg": "rgba(251, 191, 36, 0.1)",
                "--card-icon-border": "rgba(251, 191, 36, 0.15)",
              } as React.CSSProperties}
            >
              <div className="blog-surface-card__icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fbbf24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  <path d="M12 8v4M12 16h.01" />
                </svg>
              </div>
              <h3 className="blog-surface-card__title">Control Plane</h3>
              <p className="blog-surface-card__desc">
                Centralized RBAC, routing policies, cost management, and audit trails. Provision
                entities from your corporate directory via SAML, OIDC, or SCIM. One pane of
                glass for all AI activity.
              </p>
            </div>
          </div>
        </section>

        <hr className="blog-divider" />

        {/* ── Section 3: Three Rings Architecture ── */}
        <section className="blog-section">
          <span className="blog-section__label">Architecture</span>
          <h2 className="blog-section__heading">Three Rings</h2>
          <p className="blog-section__text">
            Every request flows through three concentric layers. Each ring adds policy enforcement
            without adding latency &mdash; decisions are made locally, at the edge, in microseconds.
          </p>

          <div className="blog-rings">
            {/* Ring 1 */}
            <div
              className="blog-ring"
              style={{
                "--ring-color": "#fbbf24",
                "--ring-glow": "rgba(251, 191, 36, 0.08)",
                "--ring-bg": "rgba(251, 191, 36, 0.08)",
                "--ring-border": "rgba(251, 191, 36, 0.15)",
              } as React.CSSProperties}
            >
              <div className="blog-ring__number">1</div>
              <div className="blog-ring__body">
                <div className="blog-ring__subtitle">Outermost Ring</div>
                <h3 className="blog-ring__title">RBAC &amp; Guardrails</h3>
                <p className="blog-ring__desc">
                  Who can use what. Entity-level permissions for developers, pipelines, agents,
                  hosts, service accounts, and teams. Every entity is auto-provisioned from your
                  corporate directory. Policies define which models, tools, and file paths each
                  entity can access.
                </p>
                <div className="blog-ring__features">
                  {["Entity model", "Role hierarchy", "Policy engine", "Directory sync", "Audit log"].map(t => (
                    <span key={t} className="blog-ring__feature-tag">{t}</span>
                  ))}
                </div>
              </div>
            </div>

            {/* Ring 2 */}
            <div
              className="blog-ring"
              style={{
                "--ring-color": "#a78bfa",
                "--ring-glow": "rgba(167, 139, 250, 0.08)",
                "--ring-bg": "rgba(167, 139, 250, 0.08)",
                "--ring-border": "rgba(167, 139, 250, 0.15)",
              } as React.CSSProperties}
            >
              <div className="blog-ring__number">2</div>
              <div className="blog-ring__body">
                <div className="blog-ring__subtitle">Middle Ring</div>
                <h3 className="blog-ring__title">Intelligent Routing</h3>
                <p className="blog-ring__desc">
                  Policy-driven provider and model selection. Route requests based on task type,
                  cost budget, latency requirements, or compliance zone. Automatic fallback chains.
                  Cost optimization that works across every provider simultaneously.
                </p>
                <div className="blog-ring__features">
                  {["Policy routing", "Cost optimization", "Fallback chains", "Latency targets", "Compliance zones"].map(t => (
                    <span key={t} className="blog-ring__feature-tag">{t}</span>
                  ))}
                </div>
              </div>
            </div>

            {/* Ring 3 */}
            <div
              className="blog-ring"
              style={{
                "--ring-color": "#4f8fff",
                "--ring-glow": "rgba(79, 143, 255, 0.08)",
                "--ring-bg": "rgba(79, 143, 255, 0.08)",
                "--ring-border": "rgba(79, 143, 255, 0.15)",
              } as React.CSSProperties}
            >
              <div className="blog-ring__number">3</div>
              <div className="blog-ring__body">
                <div className="blog-ring__subtitle">Innermost Ring</div>
                <h3 className="blog-ring__title">Universal Bridge</h3>
                <p className="blog-ring__desc">
                  Normalize any AI vendor into one interface. MCP servers, OpenAI, Anthropic,
                  Ollama, Azure, Bedrock &mdash; your application code talks to one API. Swap
                  providers without changing a single line of application code.
                </p>
                <div className="blog-ring__features">
                  {["MCP protocol", "OpenAI compat", "Anthropic SDK", "Ollama native", "Azure / Bedrock", "Provider swap"].map(t => (
                    <span key={t} className="blog-ring__feature-tag">{t}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <hr className="blog-divider" />

        {/* ── Section 4: Config example ── */}
        <section className="blog-section">
          <span className="blog-section__label">Configuration</span>
          <h2 className="blog-section__heading">Policy as Code</h2>
          <p className="blog-section__text">
            Routing policies, RBAC rules, and cost limits are defined in YAML and version-controlled
            alongside your infrastructure. No clicking through dashboards &mdash; everything is auditable,
            reviewable, and deployable via CI.
          </p>

          <div className="blog-code-block">
            <div className="blog-code-block__header">
              <div className="blog-code-block__dots">
                <span className="blog-code-block__dot" style={{ background: "#f87171" }} />
                <span className="blog-code-block__dot" style={{ background: "#fbbf24" }} />
                <span className="blog-code-block__dot" style={{ background: "#34d399" }} />
              </div>
              <span className="blog-code-block__filename">toolos-policy.yaml</span>
              <span className="blog-code-block__lang">YAML</span>
            </div>
            <div className="blog-code-block__body">
              <pre>{yamlRouting()}</pre>
            </div>
          </div>

          <div className="blog-code-block">
            <div className="blog-code-block__header">
              <div className="blog-code-block__dots">
                <span className="blog-code-block__dot" style={{ background: "#f87171" }} />
                <span className="blog-code-block__dot" style={{ background: "#fbbf24" }} />
                <span className="blog-code-block__dot" style={{ background: "#34d399" }} />
              </div>
              <span className="blog-code-block__filename">rbac-entities.yaml</span>
              <span className="blog-code-block__lang">YAML</span>
            </div>
            <div className="blog-code-block__body">
              <pre>{yamlRbac()}</pre>
            </div>
          </div>
        </section>

        <hr className="blog-divider" />

        {/* ── Section 5: Features built ── */}
        <section className="blog-section">
          <span className="blog-section__label">What is Built</span>
          <h2 className="blog-section__heading">Ship-Ready Features</h2>
          <p className="blog-section__text">
            These are not wireframes. Every feature below is built, functional, and running
            in the ToolOS developer platform today.
          </p>

          <div className="blog-features-grid">
            {FEATURES.map((feat) => (
              <div key={feat.name} className="blog-feature">
                <div
                  className="blog-feature__icon"
                  style={{
                    "--feat-bg": `${feat.color}12`,
                    "--feat-border": `${feat.color}20`,
                  } as React.CSSProperties}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={feat.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d={feat.icon} />
                  </svg>
                </div>
                <div className="blog-feature__name">{feat.name}</div>
                <div className="blog-feature__desc">{feat.desc}</div>
              </div>
            ))}
          </div>
        </section>

        <hr className="blog-divider" />

        {/* ── Section 6: Open Source ── */}
        <section className="blog-section">
          <span className="blog-section__label">Open Source</span>
          <h2 className="blog-section__heading">OTEL-Style Foundation</h2>
          <p className="blog-section__text">
            ToolOS follows the <strong>OpenTelemetry playbook</strong>: an open-source core that
            defines the standard, with enterprise extensions for organizations that need them.
            The bridge protocol, routing engine, and developer platform are open. Enterprise
            features like SSO/SCIM provisioning, compliance reporting, and multi-cluster
            management are commercial add-ons.
          </p>

          <div className="blog-oss-strip">
            <div className="blog-oss-card">
              <h4 className="blog-oss-card__title">Open Core</h4>
              <p className="blog-oss-card__desc">
                Universal bridge protocol, routing engine, developer workstation, RBAC
                primitives, cost tracking, drift detection. Everything you need to run
                ToolOS for a team.
              </p>
            </div>
            <div className="blog-oss-card">
              <h4 className="blog-oss-card__title">Enterprise Extensions</h4>
              <p className="blog-oss-card__desc">
                SAML/OIDC/SCIM directory sync, multi-cluster control plane, compliance
                audit exports, SLA-backed support, air-gapped deployment, SCIF-in-a-box
                hardened images.
              </p>
            </div>
            <div className="blog-oss-card">
              <h4 className="blog-oss-card__title">Community Plugins</h4>
              <p className="blog-oss-card__desc">
                Plugin registry for custom tool integrations, agent team compositions,
                and workflow recipes. Plugins ship default team compositions with
                persona, role, and count definitions.
              </p>
            </div>
          </div>
        </section>

        {/* ── CTA ── */}
        <section className="blog-cta">
          <h2 className="blog-cta__title">
            Ready to unify your AI toolchain?
          </h2>
          <p className="blog-cta__text">
            ToolOS is open source and ready for early adopters. Star the repo, try the developer
            platform, or deploy the control plane in your cluster.
          </p>
          <div className="blog-cta__buttons">
            <a
              href="https://github.com/Opentool-io/opentool"
              target="_blank"
              rel="noopener noreferrer"
              className="blog-cta__btn blog-cta__btn--primary"
            >
              <IconGitHub />
              Star on GitHub
            </a>
            <button
              className="blog-cta__btn blog-cta__btn--ghost"
              onClick={navigateHome}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                <path d="M8 21h8M12 17v4" />
              </svg>
              Try the Platform
            </button>
          </div>
        </section>

        {/* ── Footer ── */}
        <footer className="blog-footer">
          <p className="blog-footer__text">
            Built by{" "}
            <a href="https://github.com/Opentool-io" target="_blank" rel="noopener noreferrer">
              OpenTool
            </a>
            {" "}&mdash; open source AI governance for the rest of us.
          </p>
        </footer>
      </div>
    </div>
  );
}

// ── YAML code snippets (syntax-highlighted via JSX) ─────────────

function yamlRouting() {
  return (
    <>
      <span className="blog-syn-comment"># toolos-policy.yaml</span>{"\n"}
      <span className="blog-syn-comment"># Routing policy: cost-optimized with compliance zones</span>{"\n"}
      {"\n"}
      <span className="blog-syn-key">apiVersion</span>: <span className="blog-syn-str">toolos.io/v1</span>{"\n"}
      <span className="blog-syn-key">kind</span>: <span className="blog-syn-str">RoutingPolicy</span>{"\n"}
      <span className="blog-syn-key">metadata</span>:{"\n"}
      {"  "}<span className="blog-syn-prop">name</span>: <span className="blog-syn-str">production-routing</span>{"\n"}
      {"  "}<span className="blog-syn-prop">namespace</span>: <span className="blog-syn-str">platform</span>{"\n"}
      {"\n"}
      <span className="blog-syn-key">spec</span>:{"\n"}
      {"  "}<span className="blog-syn-prop">rules</span>:{"\n"}
      {"    "}- <span className="blog-syn-prop">match</span>:{"\n"}
      {"        "}<span className="blog-syn-prop">task_type</span>: <span className="blog-syn-str">code_generation</span>{"\n"}
      {"        "}<span className="blog-syn-prop">entity_role</span>: <span className="blog-syn-str">developer</span>{"\n"}
      {"      "}<span className="blog-syn-prop">route</span>:{"\n"}
      {"        "}<span className="blog-syn-prop">provider</span>: <span className="blog-syn-str">anthropic</span>{"\n"}
      {"        "}<span className="blog-syn-prop">model</span>: <span className="blog-syn-str">claude-sonnet-4-20250514</span>{"\n"}
      {"        "}<span className="blog-syn-prop">max_tokens</span>: <span className="blog-syn-num">8192</span>{"\n"}
      {"        "}<span className="blog-syn-prop">fallback</span>:{"\n"}
      {"          "}- <span className="blog-syn-str">openai/gpt-4o</span>{"\n"}
      {"          "}- <span className="blog-syn-str">ollama/deepseek-coder</span>{"\n"}
      {"\n"}
      {"    "}- <span className="blog-syn-prop">match</span>:{"\n"}
      {"        "}<span className="blog-syn-prop">task_type</span>: <span className="blog-syn-str">explanation</span>{"\n"}
      {"        "}<span className="blog-syn-prop">cost_budget</span>: <span className="blog-syn-str">low</span>{"\n"}
      {"      "}<span className="blog-syn-prop">route</span>:{"\n"}
      {"        "}<span className="blog-syn-prop">provider</span>: <span className="blog-syn-str">ollama</span>{"\n"}
      {"        "}<span className="blog-syn-prop">model</span>: <span className="blog-syn-str">llama3.1:8b</span>{"\n"}
      {"        "}<span className="blog-syn-prop">compliance_zone</span>: <span className="blog-syn-str">local-only</span>{"\n"}
      {"\n"}
      {"  "}<span className="blog-syn-prop">cost_limits</span>:{"\n"}
      {"    "}<span className="blog-syn-prop">daily_per_entity</span>: <span className="blog-syn-str">"$25.00"</span>{"\n"}
      {"    "}<span className="blog-syn-prop">monthly_org</span>: <span className="blog-syn-str">"$5,000"</span>{"\n"}
      {"    "}<span className="blog-syn-prop">alert_threshold</span>: <span className="blog-syn-num">0.8</span>{"\n"}
    </>
  );
}

function yamlRbac() {
  return (
    <>
      <span className="blog-syn-comment"># rbac-entities.yaml</span>{"\n"}
      <span className="blog-syn-comment"># Entity definitions provisioned from corporate directory</span>{"\n"}
      {"\n"}
      <span className="blog-syn-key">apiVersion</span>: <span className="blog-syn-str">toolos.io/v1</span>{"\n"}
      <span className="blog-syn-key">kind</span>: <span className="blog-syn-str">EntityPolicy</span>{"\n"}
      <span className="blog-syn-key">metadata</span>:{"\n"}
      {"  "}<span className="blog-syn-prop">name</span>: <span className="blog-syn-str">engineering-team</span>{"\n"}
      {"\n"}
      <span className="blog-syn-key">spec</span>:{"\n"}
      {"  "}<span className="blog-syn-prop">entities</span>:{"\n"}
      {"    "}- <span className="blog-syn-prop">kind</span>: <span className="blog-syn-str">Team</span>{"\n"}
      {"      "}<span className="blog-syn-prop">name</span>: <span className="blog-syn-str">platform-eng</span>{"\n"}
      {"      "}<span className="blog-syn-prop">source</span>: <span className="blog-syn-str">scim://directory</span>{"\n"}
      {"      "}<span className="blog-syn-prop">roles</span>:{"\n"}
      {"        "}- <span className="blog-syn-str">developer</span>{"\n"}
      {"        "}- <span className="blog-syn-str">agent-operator</span>{"\n"}
      {"      "}<span className="blog-syn-prop">allowed_models</span>:{"\n"}
      {"        "}- <span className="blog-syn-str">"anthropic/*"</span>{"\n"}
      {"        "}- <span className="blog-syn-str">"openai/gpt-4o"</span>{"\n"}
      {"        "}- <span className="blog-syn-str">"ollama/*"</span>{"\n"}
      {"      "}<span className="blog-syn-prop">allowed_tools</span>:{"\n"}
      {"        "}- <span className="blog-syn-str">"file_read"</span>{"\n"}
      {"        "}- <span className="blog-syn-str">"file_write"</span>{"\n"}
      {"        "}- <span className="blog-syn-str">"shell_exec"</span>{"\n"}
      {"        "}- <span className="blog-syn-str">"web_search"</span>{"\n"}
      {"      "}<span className="blog-syn-prop">quarantine</span>:{"\n"}
      {"        "}<span className="blog-syn-prop">enabled</span>: <span className="blog-syn-bool">true</span>{"\n"}
      {"        "}<span className="blog-syn-prop">review_required</span>: <span className="blog-syn-str">["shell_exec"]</span>{"\n"}
      {"\n"}
      {"    "}- <span className="blog-syn-prop">kind</span>: <span className="blog-syn-str">Pipeline</span>{"\n"}
      {"      "}<span className="blog-syn-prop">name</span>: <span className="blog-syn-str">ci-agent</span>{"\n"}
      {"      "}<span className="blog-syn-prop">roles</span>:{"\n"}
      {"        "}- <span className="blog-syn-str">agent</span>{"\n"}
      {"      "}<span className="blog-syn-prop">allowed_models</span>:{"\n"}
      {"        "}- <span className="blog-syn-str">"ollama/codellama"</span>{"\n"}
      {"      "}<span className="blog-syn-prop">max_concurrent</span>: <span className="blog-syn-num">4</span>{"\n"}
    </>
  );
}
